{
  document.addEventListener("DOMContentLoaded", function () {
    const MultipleSlider = () => {
      const sliders = document.querySelectorAll(".Banner_Slider");
      sliders.forEach((slider, index) => {
        const parent = slider.parentElement;
        const prevArrow = parent.querySelector(".prev");
        const nextArrow = parent.querySelector(".next");
        // Create unique pagination element per slider
        let paginationEl = parent.querySelector(".swiper-pagination");
        new Swiper(slider, {
          direction: "horizontal",
          // loop: true,
          speed: 1000,
          parallax: true, 
          autoplay: {
            delay: 10000,
            disableOnInteraction: false,
          },
          slidesPerView: 1,
          spaceBetween: 0,
          grabCursor: true,

          navigation: {
            nextEl: nextArrow,
            prevEl: prevArrow,
          },
          pagination: {
            el: paginationEl,
            clickable: true,
            renderBullet: function (index, className) {
              return `
      <span class="${className}">
        <svg class="progress-svg" width="14" height="14">
          <circle class="bg" cx="7" cy="7" r="5"></circle>
          <circle class="progress" cx="7" cy="7" r="5"></circle>
        </svg>
      </span>
    `;
            },
          },
        });
      });
    };

    MultipleSlider();
  });
}
{
  document.addEventListener("DOMContentLoaded", function () {
    const MultipleSlider = () => {
      const MultipleSliders = document.querySelectorAll(".infoCards");
      MultipleSliders.forEach((slider, index) => {
        const prevArrow = slider.parentElement.querySelector(".prev");
        const nextArrow = slider.parentElement.querySelector(".next");

        new Swiper(slider, {
          direction: "horizontal",
          // loop: true,
          speed: 1000,
          //   autoplay: {
          //     delay: 1000,
          //     disableOnInteraction: false,
          //   },
          grabCursor: true,
          navigation: {
            nextEl: nextArrow,
            prevEl: prevArrow,
          },

          breakpoints: {
            150: {
              slidesPerView: 1,
              spaceBetween: 10,
            },
            576: {
              slidesPerView: 2,
              spaceBetween: 10,
            },
            769: {
              slidesPerView: 2.6,
              spaceBetween: 10,
            },
            1025: {
              slidesPerView: 3,
              spaceBetween: 20,
            },
            1200: {
              slidesPerView: 3,
              spaceBetween: 30,
            },
          },
        });
      });
    };
    MultipleSlider();
  });
}
{
  document.addEventListener("DOMContentLoaded", function () {
    const MultipleSlider = () => {
      const MultipleSliders = document.querySelectorAll(".Reviews_Cards");
      MultipleSliders.forEach((slider, index) => {
        const prevArrow = slider.parentElement.querySelector(".prev");
        const nextArrow = slider.parentElement.querySelector(".next");
        const paginationEl =
          slider.parentElement.querySelector(".swiper-pagination");
        new Swiper(slider, {
          direction: "horizontal",
          // loop: true,
          speed: 1000,
          //   autoplay: {
          //     delay: 1000,
          //     disableOnInteraction: false,
          //   },
          grabCursor: true,
          navigation: {
            nextEl: nextArrow,
            prevEl: prevArrow,
          },
          pagination: {
            el: paginationEl,
            clickable: true,
          },
          breakpoints: {
            150: {
              slidesPerView: 1,
              spaceBetween: 10,
            },
            576: {
              slidesPerView: 2,
              spaceBetween: 10,
            },
            769: {
              slidesPerView: 2.6,
              spaceBetween: 10,
            },
            1025: {
              slidesPerView: 3,
              spaceBetween: 20,
            },
            1200: {
              slidesPerView: 3,
              spaceBetween: 30,
            },
          },
        });
      });
    };
    MultipleSlider();
  });
}
